
import Vue from 'vue'
import {Action, Getter, namespace} from 'vuex-class'
import {Component} from 'vue-property-decorator'
import {validationMixin} from 'vuelidate'
import {required, sameAs} from 'vuelidate/lib/validators'

const uiModule = namespace('ui')
const authModule = namespace('auth')

@Component({
  mixins: [validationMixin],
  validations: {
    form: {
      MOT_DE_PASSE: {
        required
      },
      MOT_DE_PASSE_CONFIRM: {
        sameAsPassword: sameAs('MOT_DE_PASSE')
      }
    }
  }
})
export default class App extends Vue {
  @uiModule.Getter('isLoadingGetter') isLoading: any
  @authModule.Action('updatePasswordAction') updatePassword: any

  form: any = {
    MOT_DE_PASSE: '',
    MOT_DE_PASSE_CONFIRM: ''
  }

  submitForm() {
    this.$v.$touch()
    if (!this.$v.$invalid) {
      this.updatePassword({
        formParams: this.form,
        queryParams: null
      }).then((data) => {
        this.form = {
          MOT_DE_PASSE: '',
          MOT_DE_PASSE_CONFIRM: ''
        }
        this.$v.$reset()
        Vue.notify({
          group: 'user',
          type: 'success',
          title: 'Confirmation',
          text: 'Le mot de passe a bien été changé !'
        })
      })
    }
  }
}
